import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./dropDown.css";

const BookingSourceDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    // { value: "fresh", label: "Fresh" },
    { value: "resale", label: "Resale" },
    { value: "business", label: "Business" },
  ];

  const selectedOption = options.find((opt) => opt.value === value);

  const handleSelect = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };

  return (
    <div className="prop-dropdown-wrapper">
      <button
        className="prop-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="prop-icon">{selectedOption?.icon}</span>
        <span className="prop-label">{selectedOption?.label}</span>
        <ChevronDown
          size={18}
          className={`prop-chevron ${isOpen ? "open" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="prop-menu">
          {options.map((option) => (
            <button
              key={option.value}
              className={`prop-option ${value === option.value ? "active" : ""}`}
              onClick={() => handleSelect(option.value)}
            >
              <span className="prop-option-icon">{option.icon}</span>
              <span className="prop-option-label">{option.label}</span>
              {value === option.value && (
                <span className="prop-checkmark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default BookingSourceDropdown;